export default "__VITE_ASSET__Ck45iyRV__"